.filters {
  padding: 4px 0 8px;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px var(--gutter);
  position: relative;
  animation: bb-fade-in var(--t-med) var(--ease);
}

.unread {
  background: linear-gradient(90deg, rgb(var(--accent-rgb) / 0.08), transparent 70%);
}

.unread::before {
  content: '';
  position: absolute;
  left: 5px;
  top: 50%;
  width: 6px;
  height: 6px;
  margin-top: -3px;
  border-radius: 50%;
  background: var(--accent);
}

.text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
  font-size: var(--fs-sm);
  line-height: 1.4;
  color: var(--text-2);
}

.text strong {
  color: var(--text);
  font-weight: 700;
}

.text time {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.quote {
  color: var(--text-2);
}

.thumb {
  width: 44px;
  height: 58px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  background: var(--surface-2);
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
